import { buildCombinedKey } from '../buildCombinedKey';
export const populateModulePaths = (outputMap, module, currentPath = []) => {
  if (module.key && module.type) {
    outputMap.set(buildCombinedKey(module.type, module.key), currentPath.join('.'));
  }
  if (module.zones) {
    Object.entries(module.zones).forEach(([zoneKey, value]) => {
      value.forEach((m, i) => {
        if (m.data) {
          populateModulePaths(outputMap, m.data, [...currentPath, `zones.${zoneKey}[${i}].data`]);
        }
      });
    });
  }
};
export const getModulePathsInSurface = surface => {
  const outputMap = new Map();
  populateModulePaths(outputMap, surface);
  return outputMap;
};